export default {
  title: 'Vetrina',
  fields: {
    has_reservations: {
      label: 'Mostra prenotazioni sulla vetrina',
    },
  },
  button: {
    save: 'Salva',
    preview: 'Anteprima',
  },
  no_storefront: {
    title: 'Nessuna vetrina trovata',
    description: 'Crea una vetrina.',
    button: {
      storefront: 'Vai alla vetrina',
    },
  },
  response_messages: {
    success: 'Aggiornamento riuscito.',
    failed: 'Aggiornamento non riuscito.',
  },
};
